



















































































import Vue from 'vue';
import { firebase } from 'mostra';
// import * as firebase from '@/plugins/firebase';

export type DataType = {
  email: {
    uid: string;
    email: string;
  };
  stop: {
    email: string;
  };
  stopPreview: any | null;
  isStopConfirmOpen: boolean;
  isStopBusy: boolean;
};

export default Vue.extend({
  name: 'admin-account-setting',
  data(): DataType {
    return {
      email: {
        uid: '',
        email: '',
      },
      stop: {
        email: '',
      },
      stopPreview: null,
      isStopConfirmOpen: false,
      isStopBusy: false,
      // email: {
      //   uid: '839PkxGA2LVZwibq2FKUM1F7Zky1',
      //   email: 'taiki.nakada+011101@east-fields.co.jp',
      // },
    };
  },
  computed: {
    stopConfirmTexts(): string[] {
      const p: any = this.stopPreview;
      if (!p) {
        return [
          '停止プレビューがありません。',
        ];
      }

      const lines: string[] = [];
      lines.push('以下のユーザー停止を実行します（元に戻せません）');
      lines.push(`検索Email: ${this.stop.email}`);
      lines.push(`対象UID: ${p?.target?.uid || '-'}`);
      lines.push(`Auth Email: ${p?.target?.authEmail || '-'}`);

      const cid = p?.userDoc?.cid;
      lines.push(`cid: ${cid || '(なし)'}`);

      if (p?.company?.cid) {
        const users = Array.isArray(p?.company?.activeUsers) ? p.company.activeUsers : [];
        lines.push(`企業内の有効ユーザ数: ${users.length}`);
        users.forEach((u: any) => {
          lines.push(`- ${u?.uid || '-'} / ${u?.email || '-'}`);
        });
        if (p?.company?.hasOtherActiveUsers) {
          lines.push('注意: 同一企業内に他の有効ユーザーがいます。');
          lines.push('「はい」を押すと、企業内の有効ユーザーを全て停止します。');
        }
      }

      if (p?.exhibitorCascade) {
        const brandCount = Array.isArray(p.exhibitorCascade.brandIds) ? p.exhibitorCascade.brandIds.length : 0;
        lines.push(`出展者連鎖停止(見積): ブランド ${brandCount} / ブース ${p.exhibitorCascade.boothCount || 0} / 商品 ${p.exhibitorCascade.itemCount || 0}`);
      }

      lines.push('処理内容: Firestore isActivate=false + email退避 + Firebase Auth削除');
      lines.push('本当に実行しますか？');
      return lines;
    },
  },
  methods: {
    getNormalizedStopEmail(): string | null {
      const email = typeof this.stop.email === 'string' ? this.stop.email.trim() : '';
      if (!email) {
        this.$error('停止対象のメールアドレスを入力してください。');
        return null;
      }
      this.stop.email = email;
      return email;
    },
    async ensureAdminClaim(): Promise<boolean> {
      const user = firebase.auth().currentUser;
      if (!user) {
        this.$error('ログイン状態を確認できません。再ログインしてください。');
        return false;
      }

      const idTokenResult = await user.getIdTokenResult(true);
      const isAdmin = Boolean((idTokenResult?.claims as any)?.admin);
      if (!isAdmin) {
        this.$error('admin claim がありません。管理者権限を付与後、再ログインしてください。');
        return false;
      }
      return true;
    },
    async onClickEmail() {
      try {
        await firebase
          .functions('admins-account-email-changeEmail', this.email);
        this.$success('保存しました');
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
      // try {
      //   this.$loading(true);
      //   await firebase
      //     .functions('setCustomTokenAdmin', {
      //       uid: this.admin.uid,
      //       admin: this.admin.admin,
      //     });
      //   this.$success('保存しました。');
      // } catch (error: any) {
      //   this.$error('保存に失敗しました。', error);
      // } finally {
      //   this.$loading(false);
      // }
    },
    closeStopConfirm() {
      if (this.isStopBusy) return;
      this.isStopConfirmOpen = false;
    },
    onDenyStop() {
      if (this.isStopBusy) return;
      this.isStopConfirmOpen = false;
      this.stopPreview = null;
      this.$success('キャンセルしました');
    },
    async onClickStopPreview() {
      if (this.isStopBusy) return;
      try {
        if (!(await this.ensureAdminClaim())) return;
        const stopEmail = this.getNormalizedStopEmail();
        if (!stopEmail) return;
        this.isStopBusy = true;
        this.$loading(true);
        const res: any = await firebase.functions('admins-account-stop-previewStopUserByEmail', {
          email: stopEmail,
        });
        this.stopPreview = res?.data ?? res;
        this.isStopConfirmOpen = true;
      } catch (error: any) {
        this.$error('停止プレビューに失敗しました。', error);
      } finally {
        this.isStopBusy = false;
        this.$loading(false);
      }
    },
    async onConfirmStop() {
      if (this.isStopBusy) return;
      try {
        if (!(await this.ensureAdminClaim())) return;
        const stopEmail = this.getNormalizedStopEmail();
        if (!stopEmail) return;
        this.isStopBusy = true;
        this.$loading(true);

        const hasOtherActiveUsers = Boolean(this.stopPreview?.company?.hasOtherActiveUsers);
        const params: any = {
          email: stopEmail,
          confirm: true,
        };
        if (hasOtherActiveUsers) {
          params.confirmCompanyCascade = true;
        }

        await firebase.functions('admins-account-stop-stopUserByEmail', params);
        this.$success('ユーザー停止を実行しました');

        this.isStopConfirmOpen = false;
        this.stopPreview = null;
        this.stop.email = '';
      } catch (error: any) {
        this.$error('ユーザー停止に失敗しました。', error);
      } finally {
        this.isStopBusy = false;
        this.$loading(false);
      }
    },
  },
});
